module.exports = __webpack_public_path__ + "img/Poorter_hotel-170-HDR.6262c858.jpg";